import { ComplaintModalLayout } from "./ComplaintModalLayout";

export default function ComplaintViewDialog({
  closeDialog,
  viewDetails,
  openImageSlider,
  setImageSliderCurrentIndex,
  successView,
  accept,
  reject,
  setComplaintViewDetails,
}) {
  const pictureList = viewDetails.pictureList
  return (
    <ComplaintModalLayout
      value={{
        closeDialog,
        successView,
        viewDetails,
        pictureList,
        accept,
        reject,
        openImageSlider,
        setImageSliderCurrentIndex,
        setComplaintViewDetails,
      }}
    >
      <ComplaintModalLayout.Header />

      <ComplaintModalLayout.Content>
        <ComplaintModalLayout.Details />
        <ComplaintModalLayout.Pictures />
        <ComplaintModalLayout.Remarks />
      </ComplaintModalLayout.Content>

      <ComplaintModalLayout.Footer />
    </ComplaintModalLayout>
  );
}
